




import { Filter } from '@empathy/search-types';
import { Component, Prop, Vue } from 'vue-property-decorator';
import DefaultRating from '../default-rating.vue';

@Component({
  components: {
    DefaultRating
  }
})
export default class RatingFilterTitle extends Vue {
  @Prop({ required: true })
  filter: Filter;

  get rating() {
    return Number.parseFloat(this.filter.title);
  }
}
